import {
  InnerBlocks,
  useInnerBlocksProps,
  useBlockProps,
  BlockControls,
  InspectorControls,
} from '@wordpress/block-editor';

import { __ } from '@wordpress/i18n';
import { PanelBody, PanelRow } from '@wordpress/components';

import { ToggleSwitch } from '@components/ui/ToggleSwitch';

export default function Edit({ attributes, setAttributes }) {
  const { addAsBlockStyles, flexClass, metadata } = attributes;

  const blockProps = useBlockProps({ className: 'bites-wrap' });

  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    {
      className: `bf_layout ${flexClass}`,
    },
    {
      template: [['core/paragraph']],
    }
  );

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title={__('Block Styles', 'blockbite')} initialOpen={true}>
          <p>Add BlockStyles for the outer element of your component</p>
          <PanelRow>
            <ToggleSwitch
              checked={addAsBlockStyles}
              onChange={(value) => setAttributes({ addAsBlockStyles: value })}
              label="Add as block styles"
            />
          </PanelRow>
        </PanelBody>
      </InspectorControls>
      {metadata && (
        <h4 className="text-bold my-8 block py-2 text-2xl">{metadata.name}</h4>
      )}
      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
}
